export default __webpack_public_path__ + "static/media/cp_geo_nl.9d4a525f.svg";